import { useNavigationStore } from "src/store/navigationStore";
import { useFindPath } from "../../hooks/useFindPath";
import { useAppStore } from "@/store/appStore";
import { CHAT_TYPE } from "@/types/navigation-mode";
import ImageButton from "./image-button";

export default function LocationButton() {
  const userQuery = useNavigationStore((state) => state.userQuery);
  const chatType = useAppStore((state) => state.chatType);

  const { handleUserQuery } = useFindPath();

  const updateWithCurrentLocation = async () => {
    if (chatType === CHAT_TYPE.NAVIGATION) {
      await handleUserQuery(userQuery, { useCurrentLocation: true });
    }
  };

  return (
    <ImageButton
      className="button-glass-blur"
      src="/assets/icon_location.png"
      onClick={function (): void {
        updateWithCurrentLocation();
      }}
      alt="location icon"
      size={24}
    />
  );
}
